import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SettingService } from '@services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent implements OnInit {
  @Input() bindLabel: string = 'name';
  @Input() bindValue: string = '_id';
  @Input() dropDownFor: string = '';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() maxRecords: number = 2;
  @Input() items: any[] = [];
  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any>();
  @Input() name!: string;
  @Input() ngForm!: NgForm;
  @Input() sortOrderField: string = '';
  @Input() isRequired: boolean = false;
  @Input() selectAllOption: boolean = true;
  languageChangeSubscription!: Subscription;
  constructor(
    public _settingService: SettingService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.dropDownFor != '') {
      this.languageChangeSubscription = this.translate.onLangChange.subscribe((event) => {
        this.getAllItems(event.lang);
      });
    }
    this.selectAllForDropdownItems(this.items);
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange.items) {
      this.selectAllForDropdownItems(this.items);
    }
  }

  getAllItems(lang: string) {
    this._settingService
      .getDropDownList({
        pageLimit: 100,
        pageNum: 1,
        dropDownFor: this.dropDownFor,
        sortField: this.sortOrderField,
        sortOrder: 'asc',
      })
      .subscribe({
        next: (response: any) => {
          this.items = response?.data.map((item: any) => ({
            name: lang === 'ar' ? item.name.arabic : item.name.hebrew,
            id: item._id,
          }));
          this.selectAllForDropdownItems(this.items);
        },
      });
  }

  selectAllForDropdownItems(items: any[]) {
    const allSelect = (items: any[]) => {
      items.forEach((element) => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };
    allSelect(items);
  }

  onChange() {
    this.selectedItemsChange.emit(this.selectedItems);
  }
}
